import React, { useEffect, useState } from "react";
import { HashRouter, Routes, Route } from "react-router-dom";

import "./App.scss";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Sidebar from "./Components/Sidebar";
import ScrollTop from "./Components/ScrollTop";

import Home from "./Pages/Home";
import Portfolio from "./Pages/Portfolio";
import Services from "./Pages/Services";
import AboutUs from "./Pages/AboutUs";
import FormConfirm from "./Pages/FormConfirm";

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Wait for full page load
    const handleLoad = () => setLoading(false);

    if (document.readyState === "complete") {
      setLoading(false); // already loaded
    } else {
      window.addEventListener("load", handleLoad);
    }

    return () => window.removeEventListener("load", handleLoad);
  }, []);

  useEffect(() => {
    AOS.init({
      once: true, // Animate once
    });
  }, []);
  return (
    <HashRouter>
      {loading && (
        <div className="global-loader">
          <table width="100%" cellPadding="0" cellSpacing="0" border="0">
            <tbody>
              <tr>
                <td><div>L<span className="spinner"></span>ADING...</div></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {!loading && (
        <>
          <ScrollTop />
          <Header />
          <main>
            <div className="content fix">
              <Routes>
                <Route path="/" name="Home" element={<Home />} />
                <Route path="/Portfolio" name="Portfolio" element={<Portfolio />} />
                <Route path="/Services" name="Services" element={<Services />} />
                <Route path="/About-Us" name="About Us" element={<AboutUs />} />
                <Route path="/Form-Confirm" name="Form Confirm" element={<FormConfirm />} />
              </Routes>
            </div>
          </main>
          <Footer />
          <Sidebar />
        </>
      )}
    </HashRouter>
  );
}

export default App;
